/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { BooleanHelper, StorageKey, StorageManager } from "@bms/common";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const usePreviewMode = () => {
  const [previewMode, setPreviewMode] = useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();

  const exitPreviewMode = useCallback(async () => {
    await StorageManager.setValue(StorageKey.previewMode, false);
    await StorageManager.deleteValue(StorageKey.configuration);
    setPreviewMode(false);

    const queryParams = new URLSearchParams(location.search);

    if (queryParams.has("preview")) {
      queryParams.delete("preview");
      history.replace({
        search: queryParams.toString(),
      });
    }

    window.location.reload();
  }, [history, location.search]);

  const init = async () => {
    const previewModeStorageValue = await StorageManager.getValue(
      StorageKey.previewMode,
    );
    const previewModeValue = BooleanHelper.toBool(previewModeStorageValue);

    setPreviewMode(previewModeValue);
  };

  useEffect(() => {
    init();
  }, []);

  return {
    previewMode,
    exitPreviewMode,
  };
};
